/* MerryDrop — Christmas animations v2 (no libraries)
   1) Realistic garland: sagging twisted wire + glass bulbs with sockets, glow and twinkle (SVG)
   2) Snow only inside the hero banner: 3 depth layers, soft wind, pauses off-screen
   Respects "reduce motion". */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SVGNS = 'http://www.w3.org/2000/svg';

  function el(name, attrs, parent) {
    var n = document.createElementNS(SVGNS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  /* ================= 1. GARLAND ================= */
  var COLORS = [
    { light: '#FF8A8F', base: '#E3172B', deep: '#8E0716' },  // red
    { light: '#FFE6A3', base: '#FFB21F', deep: '#B66A00' },  // amber
    { light: '#8BF0B4', base: '#17A257', deep: '#06572C' },  // green
    { light: '#A9D3FF', base: '#2C7FF2', deep: '#0F3F8F' },  // blue
    { light: '#FFFFFF', base: '#FFF0C8', deep: '#D8B66A' }   // warm white
  ];

  function rand(a, b) { return a + Math.random() * (b - a); }

  function buildGarland(box) {
    var w = box.clientWidth || window.innerWidth;
    var H = 64, top = 3, sag = w < 750 ? 13 : 17;
    var span = w < 750 ? 92 : 120;
    var swags = Math.max(2, Math.round(w / span));
    span = w / swags;

    box.innerHTML = '';
    var svg = el('svg', { viewBox: '0 0 ' + w + ' ' + H, 'aria-hidden': 'true', focusable: 'false' }, box);
    var defs = el('defs', {}, svg);

    COLORS.forEach(function (c, i) {
      var g = el('radialGradient', { id: 'mdG' + i, cx: '35%', cy: '30%', r: '75%' }, defs);
      el('stop', { offset: '0%', 'stop-color': c.light }, g);
      el('stop', { offset: '55%', 'stop-color': c.base }, g);
      el('stop', { offset: '100%', 'stop-color': c.deep }, g);
      var h = el('radialGradient', { id: 'mdH' + i }, defs);
      el('stop', { offset: '0%', 'stop-color': c.base, 'stop-opacity': '.75' }, h);
      el('stop', { offset: '100%', 'stop-color': c.base, 'stop-opacity': '0' }, h);
    });
    var sock = el('linearGradient', { id: 'mdSock', x1: '0', x2: '1' }, defs);
    el('stop', { offset: '0%', 'stop-color': '#0c1f15' }, sock);
    el('stop', { offset: '45%', 'stop-color': '#2f5a41' }, sock);
    el('stop', { offset: '100%', 'stop-color': '#0c1f15' }, sock);

    var wires = el('g', {}, svg);
    var glowLayer = el('g', {}, svg);
    var bulbLayer = el('g', {}, svg);

    var d = '';
    var bulbIdx = 0;
    for (var s = 0; s < swags; s++) {
      var x0 = s * span, x1 = x0 + span, cx = x0 + span / 2;
      var cy = top + sag * 2 + rand(-2, 2);          // control point → sag depth
      d += (s === 0 ? 'M' + x0 + ' ' + top : '') + ' Q' + cx + ' ' + cy + ' ' + x1 + ' ' + top;

      // 2 bulbs per swag at slightly random positions
      [0.3, 0.7].forEach(function (t0) {
        var t = t0 + rand(-0.05, 0.05);
        var x = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
        var y = (1 - t) * (1 - t) * top + 2 * (1 - t) * t * cy + t * t * top;
        var dx = 2 * (1 - t) * (cx - x0) + 2 * t * (x1 - cx);
        var dy = 2 * (1 - t) * (cy - top) + 2 * t * (top - cy);
        var ang = Math.atan2(dy, dx) * 180 / Math.PI + rand(-10, 10);
        var ci = bulbIdx % COLORS.length;
        var dur = rand(2.2, 4.2).toFixed(2) + 's', delay = rand(0, 3).toFixed(2) + 's';
        var style = '--md-dur:' + dur + ';--md-delay:' + delay;

        // glow (drawn behind everything)
        var gg = el('g', { transform: 'translate(' + x + ' ' + y + ') rotate(' + ang + ')' }, glowLayer);
        el('ellipse', { cx: 0, cy: 17, rx: 15, ry: 17, fill: 'url(#mdH' + ci + ')', 'class': 'md-garland__bulb-glow', style: style }, gg);

        // bulb: socket + glass + highlight
        var b = el('g', { transform: 'translate(' + x + ' ' + y + ') rotate(' + ang + ')' }, bulbLayer);
        el('rect', { x: -3.6, y: 0, width: 7.2, height: 8, rx: 1.4, fill: 'url(#mdSock)' }, b);
        el('rect', { x: -3.6, y: 2.6, width: 7.2, height: .9, fill: 'rgba(255,255,255,.18)' }, b);
        el('path', {
          d: 'M-4 8 C-7 12 -7.5 18 -5 23 C-3.3 26.6 -1.3 28.5 0 29 C1.3 28.5 3.3 26.6 5 23 C7.5 18 7 12 4 8 Z',
          fill: 'url(#mdG' + ci + ')', 'class': 'md-garland__bulb-glass', style: style
        }, b);
        el('ellipse', { cx: -2.2, cy: 14.5, rx: 1.3, ry: 4, fill: 'rgba(255,255,255,.65)', transform: 'rotate(12 -2.2 14.5)' }, b);
        bulbIdx++;
      });
    }
    // two strands give a twisted-wire look
    el('path', { d: d, fill: 'none', stroke: '#13261b', 'stroke-width': 2.4, 'stroke-linecap': 'round' }, wires);
    el('path', { d: d, fill: 'none', stroke: '#3c6a4f', 'stroke-width': 1.2, 'stroke-dasharray': '3 3', 'stroke-linecap': 'round' }, wires);
    // little hooks where the swags meet
    for (var k = 0; k <= swags; k++) el('circle', { cx: k * span, cy: top, r: 1.8, fill: '#13261b' }, wires);
  }

  /* ================= 2. SNOW IN THE BANNER ================= */
  function makeSnow(banner) {
    var canvas = document.createElement('canvas');
    canvas.className = 'md-banner-snow';
    canvas.setAttribute('aria-hidden', 'true');
    banner.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, flakes = [], visible = true, raf = null, t = 0;

    // depth layers: far / mid / near / bokeh
    var LAYERS = [
      { share: .45, r: [.6, 1.3], vy: [.25, .55], o: [.35, .6], blur: 0 },
      { share: .35, r: [1.3, 2.3], vy: [.55, 1.0], o: [.6, .85], blur: 1 },
      { share: .17, r: [2.4, 3.8], vy: [1.0, 1.7], o: [.8, 1], blur: 2 },
      { share: .03, r: [5, 8],    vy: [1.2, 1.8], o: [.15, .3], blur: 6 }
    ];

    function flake(L, randomY) {
      return {
        L: L,
        x: Math.random() * w,
        y: randomY ? Math.random() * h : -10,
        r: rand(L.r[0], L.r[1]),
        vy: rand(L.vy[0], L.vy[1]),
        o: rand(L.o[0], L.o[1]),
        ph: Math.random() * 6.28,
        sw: rand(.006, .02)
      };
    }

    // snow that has landed: a height map along the bottom edge
    var COL = 4, ground = [], maxG = 40;

    function resize() {
      var rect = banner.getBoundingClientRect();
      w = rect.width; h = rect.height;
      if (!w || !h) return;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var total = Math.min(220, Math.round(w * h / (w < 750 ? 5200 : 7000)));
      flakes = [];
      LAYERS.forEach(function (L) {
        for (var i = 0; i < Math.round(total * L.share); i++) flakes.push(flake(L, true));
      });
      maxG = Math.max(22, Math.min(46, h * 0.07));
      var n = Math.ceil(w / COL) + 2, old = ground;
      ground = [];
      for (var c = 0; c < n; c++) ground.push(old[c] !== undefined ? Math.min(old[c], maxG) : 4 + Math.random() * 3);
    }

    function groundAt(x) { var c = Math.max(0, Math.min(ground.length - 1, Math.round(x / COL))); return ground[c]; }

    // a flake lands: raise the bank there and smooth it out a little
    function land(x, r) {
      var c = Math.round(x / COL), add = r * 0.9;
      for (var d = -3; d <= 3; d++) {
        var k = c + d;
        if (k < 0 || k >= ground.length) continue;
        var g = ground[k] + add * (1 - Math.abs(d) / 4) * (1 - ground[k] / maxG);
        ground[k] = Math.min(maxG, g);
      }
    }

    function drawGround() {
      // gentle settling so the bank stays soft and wavy
      for (var c = 1; c < ground.length - 1; c++) ground[c] = ground[c] * 0.96 + (ground[c - 1] + ground[c + 1]) * 0.02;
      var grad = ctx.createLinearGradient(0, h - maxG, 0, h);
      grad.addColorStop(0, '#ffffff');
      grad.addColorStop(1, '#e4edf3');
      ctx.shadowBlur = 0;
      ctx.beginPath();
      ctx.moveTo(0, h);
      for (var c2 = 0; c2 < ground.length; c2++) ctx.lineTo(c2 * COL, h - ground[c2]);
      ctx.lineTo(w, h);
      ctx.closePath();
      ctx.fillStyle = grad;
      ctx.fill();
      // soft blue-grey rim so the growing bank reads against white snow
      ctx.beginPath();
      for (var c3 = 0; c3 < ground.length; c3++) {
        var gx = c3 * COL, gy = h - ground[c3] + 1.5;
        if (c3) ctx.lineTo(gx, gy); else ctx.moveTo(gx, gy);
      }
      ctx.strokeStyle = 'rgba(120,155,180,.45)';
      ctx.lineWidth = 1.5;
      ctx.stroke();
    }

    function draw() {
      raf = null;
      if (!visible) return;
      t += 0.004;
      var wind = Math.sin(t) * 0.35 + 0.15;            // gentle gusts
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.ph += f.sw;
        f.y += f.vy;
        f.x += Math.sin(f.ph) * 0.35 + wind * (f.r / 3);
        if (f.L.blur < 6 && f.y + f.r >= h - groundAt(f.x)) {   // touched the snow bank
          if (f.r > 1) land(f.x, f.r);
          flakes[i] = flake(f.L, false);
          continue;
        }
        if (f.y > h + 10) { flakes[i] = flake(f.L, false); continue; }
        if (f.x > w + 10) f.x = -10; else if (f.x < -10) f.x = w + 10;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, 6.2832);
        ctx.fillStyle = 'rgba(255,255,255,' + f.o + ')';
        ctx.shadowColor = 'rgba(255,255,255,.9)';
        ctx.shadowBlur = f.L.blur;
        ctx.fill();
      }
      drawGround();
      raf = requestAnimationFrame(draw);
    }

    function start() { if (!raf && visible && !document.hidden) raf = requestAnimationFrame(draw); }

    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(banner);
    else window.addEventListener('resize', resize);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; start(); }).observe(banner);
    }
    document.addEventListener('visibilitychange', start);
    resize();
    start();
  }

  /* ================= INIT ================= */
  function init() {
    var g = document.querySelector('.md-garland');
    if (g && !g.dataset.mdReady) {
      g.dataset.mdReady = '1';
      buildGarland(g);
      var to, lastW = g.clientWidth;
      window.addEventListener('resize', function () {
        if (g.clientWidth === lastW) return;   // ignore mobile address-bar resizes
        lastW = g.clientWidth;
        clearTimeout(to);
        to = setTimeout(function () { buildGarland(g); }, 200);
      });
    }
    document.querySelectorAll('.banner').forEach(function (b) {
      if (!b.querySelector('.banner__media')) return;
      if (b.querySelector('.banner__media.placeholder')) b.classList.add('md-hero');   // no photo → Christmas night scene
      if (!b.querySelector('.md-banner-drift')) {
        var drift = document.createElement('div');
        drift.className = 'md-banner-drift';
        drift.setAttribute('aria-hidden', 'true');
        b.appendChild(drift);
      }
      if (!reduce && !b.querySelector('.md-banner-snow')) makeSnow(b);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // re-init when the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
